import { render, staticRenderFns } from "./index.bak.vue?vue&type=template&id=0ce568b6&scoped=true&"
import script from "./index.bak.vue?vue&type=script&lang=js&"
export * from "./index.bak.vue?vue&type=script&lang=js&"
import style0 from "./index.bak.vue?vue&type=style&index=0&id=0ce568b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce568b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ce568b6')) {
      api.createRecord('0ce568b6', component.options)
    } else {
      api.reload('0ce568b6', component.options)
    }
    module.hot.accept("./index.bak.vue?vue&type=template&id=0ce568b6&scoped=true&", function () {
      api.rerender('0ce568b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trial/record/index.bak.vue"
export default component.exports